import React from 'react';

export function FormLayoutHeader({ title, children }) {
    return (
      <div className="form-layout-header MuiListSubheader-gutters">
        <>{children && <div className="form-layout-toolbar">{children}</div>}</>
        <>{title && <div className="form-layout-title MuiTypography-root text--primary">{title}</div>}</>
      </div>
    );
  }
  